import { useState } from 'react';
import { Section, Button } from '@prosolve/common-components-ui'
import Tabs from '../../sharedComponents/Tabs';
import { FaRegCalendar, FaBookOpen, FaShareAlt, FaDollarSign, FaWhmcs, FaRegEnvelopeOpen, FaBookReader, FaFileAlt, FaInfoCircle, FaRegClock } from 'react-icons/fa';
import ImagePlaceholder from '../../../images/image-placeholder.jpg';
import useIsMobileView from "../../../hooks/useIsMobileView";
import EventHome from '../EventTabContent/EventHome/EventHome';
// import EventOverview from '../EventTabContent/EventOverview';
import EventFacilitationGuide from '../EventTabContent/EventFacilitationGuide';
import EventTravelAndExpenses from '../EventTabContent/EventTravelAndExpenses/EventTravelAndExpenses';
import EventPeople from '../EventTabContent/EventPeople/EventPeople';
// import EventLeaderboards from '../EventTabContent/EventLeaderboards';
import EventFeedback from '../EventTabContent/EventFeedback/EventFeedback';
import EventImages from '../EventTabContent/EventImages/EventImages';
import EventResources from '../EventTabContent/EventResources/EventResources';
import Cookies from 'js-cookie';
import ShareProgramModal from './ShareProgramModal';
import EditEventTopItemsModal from './EditEventTopItemsModal';
import EditMarkDeliveryNotesModal from './EditMarkDeliveryNotesModal';
import EditMarkDeliveryNotesModalStar from './EditMarkDeliveryNotesModalStar/EditMarkDeliveryNotesModalStar';
import AccountInfoModal from './AccountInfoModal';
import DisplayAndAddMultiConsultNotes from './DisplayAndAddMultiConsultNotes';
import {
  getEnv,
  allowedClientSubdomains, 
  getClientSubdomain, 
  checkHasEventTrainerPermissions,
  checkHasEditEventPermissions,
  formatDateSpan,
  isStarConsultation,
  getIsProsolveSubdomain,
  getIsEventDelivered
} from '../../../utils';
import moment from 'moment';

export default ({
  eventData,
  onReloadData,
  isPublicView,
  showFeedback
}) => {
  const userId = Cookies.get('loggedInUserId');

  const clientSubdomain = getClientSubdomain()

  const isProsolveSubdomain = getIsProsolveSubdomain()
  const isStarSubdomain = (clientSubdomain === 'star')

  const isMobileView = useIsMobileView();

  const hasEventTrainerPermissions = checkHasEventTrainerPermissions()

  const hasEditEventPermissions = checkHasEditEventPermissions()

  const {
    id: eventId,
    name = '',
    accountName = '',
    startDate = '',
    endDate = '',
    image = '',
    description = '',
    assessmentName = '',
    projectAssessmentName = '',
    deliveryNotes = '',
    projectHandoutsLink = '',
    handoutsLink: templateHandoutsLink = '',
    projectIdNumber = '',
    numberOfParticipants = '',
    projectProgramComplete = false,
    consultNotesUrl = '',
    projectStatus,
    timeZone,
    eventArrivalTime,
    eventDepartureTime,
  } = eventData;

  const handoutsLink = projectHandoutsLink || templateHandoutsLink;

  const isEventDelivered = getIsEventDelivered({ projectProgramComplete, deliveryNotes }, isStarSubdomain)

  const formatDescription = () => {
    /* 
     * No risk since data comes from our salesforce data, but if we ever find we want to
     * do things in a different way, may want to investigate DomPurify:
     * 
     * https://stackoverflow.com/questions/27934238/rendering-raw-html-with-reactjs
     */ 
    return <div dangerouslySetInnerHTML={{__html: description}} />
  }

  const hasEventTrainerTabs = (hasEventTrainerPermissions || hasEditEventPermissions)

  const tabs = ['Home'];
  if (hasEventTrainerTabs) {
    tabs.push('Facilitation Guide', 'Travel & Expenses')
  }
  tabs.push('People')
  if ((!isPublicView && hasEventTrainerTabs) || showFeedback) {
    tabs.push('Feedback')
  }
  if (hasEventTrainerTabs && !isStarSubdomain) {
    tabs.push('Photo Gallery')
  }
  tabs.push('Resources')

  const [selectedTab, setSelectedTab] = useState('Home')

  const tabContentMap = {
    'Home': <EventHome eventData={eventData} onReloadData={onReloadData} />,
    // 'About the Program': <EventOverview eventData={eventData} />,
    'Facilitation Guide': <EventFacilitationGuide eventData={eventData} isStarSubdomain={isStarSubdomain} />,
    'Travel & Expenses': <EventTravelAndExpenses eventData={eventData} />,
    'People': <EventPeople eventData={eventData} isStarSubdomain={isStarSubdomain} />,
    // 'Leaderboards': <EventLeaderboards eventData={eventData} />,
    'Feedback': <EventFeedback eventData={eventData} />,
    'Photo Gallery': <EventImages eventData={eventData} />,
    'Resources': <EventResources eventData={eventData} />,
  }

  /*
   * All tab content is created and built on render...we simply show or hide the display based on the tab selected
   */
  const getTabContent = () => {
    return Object.keys(tabContentMap).map(key => 
      <div key={key} style={{ display: (selectedTab === key) ? 'block' : 'none' }}>
        {tabContentMap[key]}
      </div>
    );
  }

  const [isTakeAttendanceModalOpen, setIsTakeAttendanceModalOpen] = useState(false)

  const [isShareProgramModalOpen, setIsShareProgramModalOpen] = useState(false)

  const [isShareSurveyModalOpen, setIsShareSurveyModalOpen] = useState(false)

  const [isAccountInfoModalOpen, setIsAccountInfoModalOpen] = useState(false)

  const [editProgramModalData, setEditProgramModalData] = useState()

  const onEditProgramClicked = () => {
    setEditProgramModalData(eventData)
  }

  const getShortSurveyLink = () => {
    const urlSubdomain = allowedClientSubdomains.indexOf(clientSubdomain) > -1 ? `${allowedClientSubdomains}.` : '';
    const env = getEnv();
    return `${urlSubdomain}events.${env ? `${env}.` : ''}prosolve.com/share/S${projectIdNumber}`
  }

  const getSurveyLink = () => {
    const urlSubdomain = allowedClientSubdomains.indexOf(clientSubdomain) > -1 ? `${allowedClientSubdomains}.` : '';
    const env = getEnv();
    return `https://${urlSubdomain}hub.${env ? `${env}.` : ''}prosolve.com/go/survey?eventId=${eventId}&assessmentName=${projectAssessmentName || assessmentName}${userId ? `&userId=${userId}` : ''}`
  }

  const getTakeAttendenceLink = () => {
    const urlSubdomain = allowedClientSubdomains.indexOf(clientSubdomain) > -1 ? `${allowedClientSubdomains}.` : '';
    const env = getEnv();
    return `${urlSubdomain}events.${env ? `${env}.` : ''}prosolve.com/attendance/E${projectIdNumber}`
  }

  const getShareEventLink = () => {
    const urlSubdomain = allowedClientSubdomains.indexOf(clientSubdomain) > -1 ? `${allowedClientSubdomains}.` : '';
    const env = getEnv();
    return `${urlSubdomain}events.${env ? `${env}.` : ''}prosolve.com/share/E${projectIdNumber}`
  }

  const openSurveyLink = () => {
    const surveyLink = getSurveyLink()
    window.open(surveyLink, "_blank")
  }

  const openExpenseLink = () => {
    // const link = isStarSubdomain ? 'https://www.concursolutions.com/nui/signin' : 'https://app.rippling.com/spend-management/dashboard/expenses?section=my+expenses';
    let link = ''
    if (isStarSubdomain) {
      link = 'https://www.concursolutions.com/nui/signin'
    } else {
      const urlSubdomain = allowedClientSubdomains.indexOf(clientSubdomain) > -1 ? `${allowedClientSubdomains}.` : '';
      const env = getEnv();
      link =  `https://${urlSubdomain}hub.${env ? `${env}.` : ''}prosolve.com/go/survey?eventId=${eventId}&assessmentName=TrainerReimbursementForm${userId ? `&userId=${userId}` : ''}`
    }
    window.open(link, '_blank')
  }

  const openHandoutLink = () => {
    window.open(handoutsLink, "_blank")
  }

  const [markDeliveryOpen, setMarkDeliveryOpen] = useState()

  const onMarkDeliveryClicked = () => {
    setMarkDeliveryOpen(eventData)
  }

  const isStarConsultationSession = isStarSubdomain && isStarConsultation(eventData)

  // Only relevant for prosolve....star always set to false to keep submit expense enabled
  const afterAllowedSubmitExpenseDateTime = !isStarSubdomain && moment().isAfter(moment(endDate).add(30, 'days'))

  const eventActionButtons = () => {

    const hasShareEventButton = !isStarSubdomain ? true : hasEditEventPermissions ? true :
      !isStarConsultationSession

    return (
      <div style={{
        display: 'flex',
        alignItems: 'stretch',
        flexWrap: 'wrap',
        rowGap: '5px',
        // columnGap: '5px',
        marginTop: '20px',
        justifyContent: isMobileView ? 'left' : 'right',
        // position: 'absolute',
        // top: '-15px',
        // right: '-10px'
        ...(isMobileView ? { overflow: 'auto', flexWrap: 'nowrap', width: 'calc(100vw - 90px)', columnGap: '7px', marginLeft: '-10px' } : {})
      }}>
        {
          isStarSubdomain && hasEventTrainerPermissions &&
          <Button
            style={{
              display: 'inline-flex',
              flexDirection: 'column',
              width: '75px',
              // height: '120px',
              padding: '2px 0px',
              border: 'none',
              marginLeft: '5px',
              textAlign: 'center'
            }}
            onClick={() => setIsTakeAttendanceModalOpen(true)}
          >
            <FaShareAlt style={{ marginBottom: '2px', color: '#0280c6', fontSize: '18px' }} />
            <span style={{ color: '#565656', fontSize: '14px' }}>{'Take Attendance'}</span>
          </Button>
        }
        {
          Boolean(handoutsLink) &&
          <Button
            style={{
              display: 'inline-flex',
              flexDirection: 'column',
              width: '65px',
              padding: '2px 0px',
              border: 'none',
              marginLeft: '5px',
              textAlign: 'center'
            }}
            onClick={openHandoutLink}
          >
            <FaFileAlt style={{ marginBottom: '2px', color: '#0280c6', fontSize: '18px' }} />
            <span style={{ color: '#565656', fontSize: '14px' }}>{'View Handouts'}</span>
          </Button>
        }
        {
          (hasEventTrainerPermissions || hasEditEventPermissions) && hasShareEventButton &&
          <Button
            style={{
              display: 'inline-flex',
              flexDirection: 'column',
              width: '65px',
              // height: '120px',
              padding: '2px 0px',
              border: 'none',
              marginLeft: '5px',
              textAlign: 'center'
            }}
            onClick={() => setIsShareProgramModalOpen(true)}
          >
            <FaShareAlt style={{ marginBottom: '2px', color: '#0280c6', fontSize: '18px' }} />
            <span style={{ color: '#565656', fontSize: '14px' }}>{'Share Event'}</span>
          </Button>
          }
          {
            Boolean(assessmentName) &&
            <Button
              style={{
                display: 'inline-flex',
                flexDirection: 'column',
                width: '65px',
                padding: '2px 0px',
                border: 'none',
                marginLeft: '5px',
                textAlign: 'center'
              }}
              onClick={openSurveyLink}
            >
              <FaBookOpen style={{ marginBottom: '2px', color: '#0280c6', fontSize: '18px' }} />
              <span style={{ color: '#565656', fontSize: '14px' }}>{'Take Survey'}</span>
            </Button>
          }
          {
            Boolean(assessmentName) && hasEventTrainerPermissions &&
            <Button
              style={{
                display: 'inline-flex',
                flexDirection: 'column',
                width: '65px',
                // height: '120px',
                padding: '2px 0px',
                border: 'none',
                marginLeft: '5px',
                textAlign: 'center'
              }}
              onClick={() => setIsShareSurveyModalOpen(true)}
            >
              <FaBookReader style={{ marginBottom: '2px', color: '#0280c6', fontSize: '18px' }} />
              <span style={{ color: '#565656', fontSize: '14px' }}>{'Share Survey'}</span>
            </Button>
          }
          {
            hasEventTrainerPermissions &&
            <Button
              style={{
                display: 'inline-flex',
                flexDirection: 'column',
                width: '65px',
                padding: '2px 0px',
                border: 'none',
                marginLeft: '5px',
                textAlign: 'center'
              }}
              $disabled={afterAllowedSubmitExpenseDateTime}
              onClick={() => !afterAllowedSubmitExpenseDateTime && openExpenseLink()}
            >
              <FaDollarSign style={{ marginBottom: '2px', color: '#0280c6', fontSize: '18px' }} />
              <span style={{ color: '#565656', fontSize: '14px' }}>{'Submit Expense'}</span>
            </Button>
          }
          {
            hasEditEventPermissions &&
            <Button
              style={{
                display: 'inline-flex',
                flexDirection: 'column',
                width: '65px',
                padding: '2px 0px',
                border: 'none',
                marginLeft: '5px',
                textAlign: 'center'
              }}
              onClick={onEditProgramClicked}
            >
              <FaWhmcs style={{ marginBottom: '2px', color: '#0280c6', fontSize: '18px' }} />
              <span style={{ color: '#565656', fontSize: '14px' }}>{'Edit'}<br />{'Event'}</span>
            </Button>
          }
      </div>
    )
  }
  
  return (
    <Section style={{ flex: 1, padding: '0px' }}>
      { 
        isTakeAttendanceModalOpen && 
        <ShareProgramModal 
          url={getTakeAttendenceLink()}
          text='To take attendence for this event, go to:'
          onClose={() => setIsTakeAttendanceModalOpen(false)} /> 
      }
      { 
        isShareProgramModalOpen && 
        <ShareProgramModal 
          url={getShareEventLink()}
          text='To share a link to this event, go to:'
          onClose={() => setIsShareProgramModalOpen(false)} /> 
      }
      {
        isShareSurveyModalOpen && 
        <ShareProgramModal 
          url={getShortSurveyLink()}
          text='To rate this program, go to:'
          onClose={() => setIsShareSurveyModalOpen(false)} /> 
      }
      {
        Boolean(editProgramModalData) &&
        <EditEventTopItemsModal 
          eventData={editProgramModalData} 
          onClose={() => setEditProgramModalData(undefined)} 
          onSuccess={() => {
            onReloadData()
            setEditProgramModalData(undefined)
          }}
        /> 
      }
      {
        Boolean(markDeliveryOpen) && 
          (isStarSubdomain ?
            <EditMarkDeliveryNotesModalStar
              eventData={markDeliveryOpen} 
              onClose={() => setMarkDeliveryOpen(undefined)} 
              onSuccess={() => {
                onReloadData()
                setMarkDeliveryOpen(undefined)
              }}
            /> 
            :
            <EditMarkDeliveryNotesModal
              eventData={markDeliveryOpen} 
              onClose={() => setMarkDeliveryOpen(undefined)} 
              onSuccess={() => {
                onReloadData()
                setMarkDeliveryOpen(undefined)
              }}
            /> 
          )
      }
      {
        isAccountInfoModalOpen &&
        <AccountInfoModal
          eventData={eventData}
          onClose={() => setIsAccountInfoModalOpen(false)} /> 
      }
      <div
        style={{
          display: 'flex',
          flexDirection: isMobileView ? 'column' : 'row',
          padding: '20px'
        }}
      >
        <div style={{
          padding: '20px',
          paddingRight: isMobileView ? '20px' : '0px'
        }}>
          <img style={{ width: isMobileView ? '100%' : 'auto', height: isMobileView ? 'auto' : '300px', borderRadius: '5px' }} src={image || ImagePlaceholder} alt='eventImage' />
        </div>
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          padding: '20px',
          position: 'relative'
        }}>
          {
            hasEventTrainerPermissions &&
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'right',
              gap: '10px', 
              position: 'absolute', 
              top: '0',
              right: '0px' 
            }}>
              {['Tentative','Canceled'].includes(projectStatus) &&
                <div style={{
                  padding: '0 10px',
                  border: 'solid 1px #F58025',
                  borderRadius: '15px',
                  color: 'hsl(26, 91%, 55%)'
                }}>
                  {projectStatus}
                </div>
              }
              <Button
                style={{
                  backgroundColor: (isEventDelivered ? 'rgb(228, 228, 228)' : 'transparent'),
                  display: 'inline-flex',
                  flexDirection: isMobileView ? 'row' : 'column',
                  width: isMobileView ? '140px' : '130px',
                  columnGap: '10px',
                  padding: '2px 0px',
                  border: 'none',
                  textAlign: 'center',
                  position: 'relative',
                }}
                onClick={onMarkDeliveryClicked}
              >
                <FaRegEnvelopeOpen style={{ marginBottom: '2px', color: '#0280c6', fontSize: '18px' }} />
                <span style={{ color: '#565656', fontSize: '14px' }}>{isEventDelivered ? 'Event Closed' : 'Close Event'}</span>
              </Button>
            </div>
          }
          <div style={{
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
            paddingTop: isMobileView ? '10px' : '0px'
          }}>
            <div style={{
              flex: 1,
              fontWeight: 'bold',
              fontSize: '16px',
              color: '#565656',
              display: 'flex',
              alignItems: 'center'
            }}>
              <FaRegCalendar style={{ marginRight: '5px' }} />
              {formatDateSpan(startDate, endDate)}
            </div>
            {/* { eventActionButtons() } */}
            {/* <div>
              <Button
                style={{
                  display: 'inline-flex',
                  padding: '3px 10px',
                  border: 'none'
                }}
                onClick={openSurveyLink}
              >
                <FaBookOpen style={{ marginRight: '10px', color: '#0280c6' }} />
                <span style={{ color: '#565656', fontSize: '14px' }}>{'Take Survey'}</span>
              </Button>
            </div> */}
          </div>
          {isProsolveSubdomain && (eventArrivalTime || eventDepartureTime) &&
            <div style={{
              display: 'flex',
              gap: '5px',
              alignItems: 'center',
              paddingTop: isMobileView ? '10px' : '3px'
            }}>
              <div style={{
                display: 'flex',
                gap: '5px',
                flex: 1,
                fontWeight: 'bold',
                fontSize: '16px',
                color: '#565656',
                alignItems: 'center'
              }}>
                <FaRegClock />
                <span>{eventArrivalTime}</span>
                <span>{eventDepartureTime ? `- ${eventDepartureTime}` : ''}</span>
                <span>{timeZone}</span>
              </div>
            </div>
          }
          <div style={{
            fontSize: '28px',
            fontWeight: 'bold',
            marginTop: '5px'
          }}>
            {name}
          </div>
          <div style={{
            marginTop: '5px',
            fontSize: '15px',
            fontStyle: 'italic',
            color: '#404040'
          }}>
            {accountName}
            {
              (isStarSubdomain && hasEventTrainerTabs) &&
              <span style={{
                position: 'relative',
                top: '1px',
                left: '5px',
                fontSize: '12px',
                color: '#0280c6',
                cursor: 'pointer'
              }}
              onClick={() => setIsAccountInfoModalOpen(true)}
              >
                <FaInfoCircle />
              </span>
            }
          </div>
          {
            (isStarSubdomain && Boolean(numberOfParticipants)) && // numberOfParticipants !== null && numberOfParticipants !== undefined) &&
            <div style={{
              marginTop: '5px',
              fontSize: '15px',
              fontStyle: 'italic',
              color: '#404040'
            }}>
              {`Number of participants: ${numberOfParticipants}`}
            </div>  
          }
          <div style={{
            marginTop: '20px',
            flex: 1
          }}>
            {formatDescription()}
          </div>
          {
            isStarSubdomain && isStarConsultationSession && !isPublicView &&
            <div style={{
              marginTop: '10px'
            }}>
              <DisplayAndAddMultiConsultNotes eventId={eventId} consultNotesUrl={consultNotesUrl} />
            </div>
          }
          { eventActionButtons() }
        </div>
      </div>
      <Tabs 
        tabs={tabs} 
        selectedTab={selectedTab} 
        setSelectedTab={setSelectedTab} 
        wrapperStyleOverride={isMobileView ? { overflowX: 'auto', overflowY: 'hidden', flexWrap: 'nowrap', width: 'calc(100vw - 50px)' } : {}} 
      />
      {getTabContent()}
    </Section>
  )
}
